import React from "react";
import { Button } from "react-bootstrap";
import LightRedBorderedButton from "../../common-components/LightRedBorderedButton";

function ButtonDice({
  buttonText1,
  buttonText2,
  onClickButton1,
  onClickButton2,
}) {
  return (
    <div className="commonBtnContainer lastMonthCtoDetails">
      <Button
        variant="outline-danger"
        className="copyLastMonth"
        onClick={onClickButton1}
      >
        {buttonText1}
      </Button>
      {buttonText2 === "Send Payment link" ? (
        <LightRedBorderedButton btnTxt={buttonText2} onClick={onClickButton2} />
      ) : (
        <Button variant="danger" className="createNew" onClick={onClickButton2}>
          {buttonText2}
        </Button>
      )}
    </div>
  );
}

export default ButtonDice;
